import { deliveryMethodSelectorSX } from '@/components/content/ProductDetails/parts/DeliveryMethodSelector/styles/deliveryMethodSelector';
import { Box, Typography } from '@mui/material';
import { FC, MouseEvent, ReactNode } from 'react';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

type DeliveryOptionProps = {
	id: string;
	label: string;
	icon: ReactNode;
	selected: boolean;
	disabled: boolean;
	onSelect: (event: MouseEvent<HTMLElement>) => void;
	/** Extra class on the option root, e.g. the 163146 express variant's analytics hook. */
	className?: string;
	/** 159071: date line + availability counter, rendered below the label. */
	children?: ReactNode;
};

/** Shared presentational shell for a single delivery method option -- see `PickupOption` and `HomeDeliveryOption`. */
export const DeliveryOption: FC<DeliveryOptionProps> = ({
	id,
	label,
	icon,
	selected,
	disabled,
	onSelect,
	children,
	className,
}) => {
	const stateClass = disabled
		? 'delivery-selector__option--disabled'
		: selected
		? 'delivery-selector__option--selected'
		: '';

	return (
		<Box
			id={id}
			className={['delivery-selector__option', stateClass, className].filter(Boolean).join(' ')}
			sx={deliveryMethodSelectorSX.option}
			onClick={disabled ? undefined : onSelect}
			aria-disabled={disabled}
			aria-pressed={selected}
		>
			<Box display="block">
				{icon}
				<Box sx={deliveryMethodSelectorSX.optionHeader}>
					<Typography
						variant="headingFeatured"
						color={disabled ? 'grey.200' : 'grey.500'}
						fontWeight={OpenSansFontWeights.semibold}
					>
						{label}
					</Typography>
				</Box>
			</Box>
			{children}
		</Box>
	);
};
